import { type ChatRoom, hasMessageDisplayContent } from 'models';
import { useMemo } from 'react';
import { ChatDetailMessagesSkeleton } from '../chat-detail-messages-skeleton';
import { useChatroomMessagesQuery } from '../queries';
import type { PendingMessage } from '../types';
import { ChatMessagesEmpty } from './chat-messages-empty';
import { ChatMessagesList } from './chat-messages-list';

type P = {
  chatroom: ChatRoom;
  onPendingMessageConsumed: () => void;
  pendingMessage?: PendingMessage;
};

const ChatMessages = ({ chatroom, onPendingMessageConsumed, pendingMessage }: P) => {
  const {
    data: messages,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useChatroomMessagesQuery({
    chatroomId: chatroom.id,
  });

  const messageList = useMemo(
    () =>
      messages?.pages
        .flat()
        .filter((message) => hasMessageDisplayContent(message))
        .toReversed(),
    [messages],
  );

  if (isLoading || !messageList) {
    return <ChatDetailMessagesSkeleton />;
  }

  if (messageList.length === 0 && !pendingMessage) {
    return <ChatMessagesEmpty />;
  }

  return (
    <ChatMessagesList
      chatroom={chatroom}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      messageList={messageList}
      onPendingMessageConsumed={onPendingMessageConsumed}
      pendingMessage={pendingMessage}
    />
  );
};

export default ChatMessages;
